import { Check } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Two-step progress bar for the booking wizard.
 *
 *   step: 1 (services) or 2 (checkout)
 *
 * Step 1 is always clickable from step 2 so the customer can edit selections.
 * Step 2 is never directly clickable — they must come through Continue.
 */
export default function BookingProgress({ step = 1 }) {
    const steps = [
        { id: 1, label: "Services" },
        { id: 2, label: "Checkout" },
    ];
    return (
        <nav className="flex items-center gap-3 sm:gap-4 mt-6" aria-label="Booking progress" data-testid="booking-progress">
            {steps.map((s, i) => {
                const active = s.id === step;
                const done = s.id < step;
                const dotClasses = `flex items-center justify-center w-7 h-7 border text-[0.6rem] tracking-[0.15em] uppercase flex-shrink-0 transition-colors ${
                    active ? "bg-[#6B1535] border-[#C29A5B] text-[#FFF8F2]"
                    : done ? "bg-[#6B1535]/20 border-[#C29A5B]/70 text-[#8F622C]"
                    : "border-[#6B1535]/15 text-[#8A6574]"
                }`;
                const labelClasses = `text-[0.65rem] tracking-[0.22em] uppercase ${
                    active ? "text-[#8F622C]"
                    : done ? "text-[#7A5262]"
                    : "text-[#8A6574]"
                }`;
                const inner = (
                    <div className="flex items-center gap-2" data-testid={`progress-step-${s.id}`}>
                        <span className={dotClasses}>{done ? <Check size={11} /> : s.id}</span>
                        <span className={labelClasses}>{s.label}</span>
                    </div>
                );
                return (
                    <div key={s.id} className="flex items-center gap-3 sm:gap-4">
                        {done && step === 2 ? (
                            <Link to="/book" className="hover:opacity-80 transition-opacity" data-testid={`progress-link-${s.id}`}>{inner}</Link>
                        ) : inner}
                        {i < steps.length - 1 && (
                            <span className={`h-px w-8 sm:w-16 ${done ? "bg-[#6B1535]" : "bg-[#6B1535]/10"}`} aria-hidden />
                        )}
                    </div>
                );
            })}
        </nav>
    );
}
